<div class="row">
  <div class="col-sm-4">
    <h3 class="sub-title">List of Users for {{roleGroup['name']}}</h3></div>
  <div class="col-sm-8 text-end">
    <a [routerLink]="['/user/guardian/create']" class="btn btn-primary" > <i class="fa fa-plus"> </i> Add User </a>
  </div>
</div>
<table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
  <thead>
  <tr>
    <th>Id</th>
    <th>Name</th>
    <th>count</th>
    <th>RoleGroup</th>
  </tr>
  </thead>

  <tbody>

  <tr *ngFor="let user of users;">
      <td>{{user['id']}}</td>
     <td>
      {{user['text']}}
      </td>
      <td>{{user['isOk']}}</td>
      <td>
        <button *ngIf="!user['isOk']"  (click)="addUserToRoleGroup(user.id)" class="btn btn-primary">Add User</button>
        <button *ngIf="user['isOk']" (click)="removeUserFromRoleGroup(user.id)" class="btn btn-danger">Remove User</button>

      </td>
  </tr>

  </tbody>

</table>

<app-spinner *ngIf="!users"> </app-spinner>
